import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import ReadinessGate from '../components/ReadinessGate';
import WorkflowStepper from '@/components/WorkflowStepper';
import { getWorkflowStatus } from '@/utils/moduleStatus';

const ExploreGate: React.FC = () => {
  const { clientId = '', workflowId = '' } = useParams<{ clientId: string; workflowId: string }>();
  const navigate = useNavigate();

  return (
    <Box
      className={'container mx-auto py-6'}
      sx={{
        display: 'flex',
        height: 'calc(100vh - 154px)',
        width: '100%',
        gap: 4,
        position: 'relative',
      }}
    >
      <WorkflowStepper
        activeStep={7}
        workflowId={workflowId}
        clientId={clientId}
        moduleCompletionStatus={getWorkflowStatus(workflowId)}
        onCollapseChange={() => {}}
        sx={{ height: 'calc(100vh - 188px)' }}
      />

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          height: '100%',
          position: 'relative'
        }}
      >
        <ReadinessGate
          clientId={clientId}
          workflowId={workflowId}
          onReady={() => navigate(`/explore/client/${clientId}/${workflowId}/view`, { replace: true })}
        />
      </Box>
    </Box>
  );
};

export default ExploreGate;


